export default class Controllers {
    constructor(client) {
        this.url = '/controllers';
        this.client = client;
    }
    Get() {
        return this.client.get(this.url);
    }
    UpdateVersion(payload) {
        return this.client.post(`${this.url}/${payload.controller.id}/update`, JSON.stringify(payload.version));
    }
    GetUpdateResult(id) {
        return this.client.get(`${this.url}/${id}/update/result`);
    }
}
export * from './payloads';
